export const immigrationStatusReqChecker = status => {
  const rules = {
    admission_category: ['CLPR', 'LPR'],
    certificate_number: ['AcqUSC', 'DerUSC'],
    immigration_status_other: ['Other'],
    naturalization_certificate_number: ['NatUSC'],
    niv_type: ['NIV'],
    no_date_expires: ['LPR', 'AcqUSC', 'DerUSC', 'NatUSC'],
    notes_only: ['None', 'NotInUS', 'PWAP', 'USC', 'UnsUSC', 'Other', 'Unknown'],
  }

  return {
    admission_category: rules.admission_category.includes(status),
    certificate_number: rules.certificate_number.includes(status),
    immigration_status_other: rules.immigration_status_other.includes(status),
    naturalization_certificate_number: rules.naturalization_certificate_number.includes(status),
    niv_type: rules.niv_type.includes(status),
    no_date_expires: rules.no_date_expires.includes(status),
    notes_only: rules.notes_only.includes(status),
  }
}

export const immigrationCleanByRules = section => {
  const fieldRules = immigrationStatusReqChecker(section.immigration_status)

  return {
    ...section,
    admission_category: fieldRules.admission_category ? section.admission_category : null,
    certificate_number: fieldRules.certificate_number ? section.certificate_number : null,
    date_expires: (fieldRules.no_date_expires || fieldRules.notes_only) ? null : section.date_expires,
    date_expires_format: section.date_expires_format,
    date_expires_uncertain: (fieldRules.no_date_expires || fieldRules.notes_only) ? null : section.date_expires_uncertain,
    date_obtained: fieldRules.notes_only ? null : section.date_obtained,
    date_obtained_format: section.date_obtained_format,
    date_obtained_uncertain: fieldRules.notes_only ? null : section.date_obtained_uncertain,
    immigration_status_other: fieldRules.immigration_status_other ? section.immigration_status_other : null,
    naturalization_certificate_number: fieldRules.naturalization_certificate_number ? section.naturalization_certificate_number : null,
    niv_type: fieldRules.niv_type ? section.niv_type : null,
    place_obtained: fieldRules.notes_only ? null : section.place_obtained,
  }
}
